function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8938 22.1056C30.8212 21.9598 30.7485 21.8139 30.7122 21.668C30.5306 21.0117 30.4216 20.3188 30.3853 19.6625C30.349 19.5166 30.3126 19.3343 30.2763 19.1884C29.7314 18.4956 29.3682 17.6569 29.1866 16.8182C29.0776 16.2712 29.0049 15.7242 28.9323 15.1772C28.787 15.8701 28.4601 16.5265 27.9515 17.037L27.9879 17.1099L21.8127 27.8671H9.46232L3.28714 17.1464L9.46232 6.4256H21.8127L21.849 6.49854C22.1759 6.49854 22.5028 6.535 22.8298 6.6444C23.6652 6.86319 24.755 7.59249 25.1545 8.43119C25.3362 8.83231 25.5178 9.19696 25.6994 9.56161C25.7721 9.67101 25.8447 9.81687 25.9174 9.92626C25.99 10.0357 26.099 10.1086 26.208 10.1815C26.2806 10.2544 26.3896 10.3274 26.4259 10.4003C26.6075 10.5097 26.7528 10.5826 26.9344 10.692C27.3703 10.9473 27.7699 11.2755 28.0605 11.7131C28.2421 10.8014 28.678 9.99919 29.3682 9.37928C29.2955 8.75938 29.2592 8.13947 29.2592 7.48309V7.41016C28.6417 6.89965 27.9879 6.4256 27.2977 6.02449C25.1545 4.78467 23.084 3.47193 20.9409 2.23211C19.1247 1.21108 17.5627 0.11713 15.4559 0.0806645C14.1119 0.0441993 12.5499 1.02876 10.9516 1.94039C8.37258 3.399 5.75721 4.8576 3.14184 6.31621C2.85125 6.49854 2.59698 6.68086 2.3427 6.86319C1.87048 7.22784 1.47091 7.70189 1.14399 8.24886C0.163229 10.0357 0.272203 11.8954 0.163229 13.9739C0.0905801 15.7607 0.163229 17.5839 0.0905801 19.4072C0.0179309 21.2305 -0.200016 23.0902 0.49015 25.0958C0.817072 26.1168 1.65254 26.7732 2.23373 27.2108C3.61406 28.1953 5.06705 29.1069 6.59268 29.8727L10.2978 32.0606C12.2593 33.191 14.1119 34.4673 16.473 34.1756C17.4537 34.0297 18.5798 33.3734 19.6695 32.717C21.3405 31.7689 23.0114 30.8573 24.646 29.9092C26.3896 28.9246 28.7507 27.9036 29.7314 26.6273C30.2763 25.8615 30.6759 24.9864 30.8575 24.0747V24.0018C30.8938 23.4548 30.8938 22.8714 30.8575 22.3244C30.8938 22.1421 30.8938 22.1421 30.8938 22.1056Z",
  fill: "#9B51E0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.49854 6.31564C11.0605 3.69014 12.2955 1.68456 13.2763 0.918791C14.5113 -0.102234 16.0006 -0.102234 16.6181 0.116557C18.9429 0.955256 17.381 6.27917 17.381 6.27917L9.49854 6.31564Z",
  fill: "url(#paint0_linear_10214_398277)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8854 27.7569C20.3234 30.3824 19.0521 32.3515 18.1076 33.1537C17.1995 33.956 15.9281 34.2477 14.7658 33.956C12.441 33.1173 14.0029 27.7569 14.0029 27.7569H21.8854Z",
  fill: "url(#paint1_linear_10214_398277)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.53494 27.7939C6.41103 27.7575 4.04993 27.6481 2.88754 27.174C1.72516 26.7729 0.817044 25.8248 0.490123 24.6215C0.0542285 22.1418 5.53924 20.8291 5.53924 20.8291L9.53494 27.7939Z",
  fill: "url(#paint2_linear_10214_398277)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.35981 17.0367C1.8705 14.3748 0.817092 12.2963 0.599145 11.0564C0.381198 9.8531 0.744443 8.61328 1.57991 7.73812C3.46879 6.13365 7.28287 10.1813 7.28287 10.1813L3.35981 17.0367Z",
  fill: "url(#paint3_linear_10214_398277)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1844 13.4998C31.1844 15.1772 31.148 16.8911 31.1117 18.6049C31.0391 20.574 31.257 22.689 30.7121 24.5123C30.8211 24.0018 30.8574 23.4913 30.7485 22.9807C30.5305 21.7409 29.4771 19.6989 27.9878 17.0005L25.8083 13.2081L21.8126 6.27969C24.9002 6.31616 27.2976 6.42555 28.46 6.8996C28.7506 7.009 29.0049 7.11839 29.2592 7.30072C29.3318 7.33718 29.4045 7.41011 29.4771 7.44658L29.5861 7.51951C29.6587 7.59244 29.7677 7.66537 29.8404 7.7383L29.9493 7.8477C30.2762 8.21235 30.5668 8.61346 30.7121 9.08751C30.7121 9.12398 30.7485 9.16044 30.7485 9.16044C30.7485 9.19691 30.7848 9.26984 30.7848 9.3063C31.2933 10.8378 31.2207 12.1506 31.1844 13.4998Z",
  fill: "#2F0B75"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4965 6.8996C28.7871 7.009 29.0414 7.15486 29.2957 7.30072C29.0414 7.15486 28.7508 7.009 28.4965 6.8996C27.3341 6.46202 24.9367 6.35262 21.8491 6.27969C24.9367 6.35262 27.2978 6.42555 28.4965 6.8996Z",
  fill: "#462B80"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8214 9.16033C30.8214 9.12367 30.8214 9.12367 30.7849 9.08701C30.7849 9.12367 30.8214 9.16033 30.8214 9.16033Z",
  fill: "#462B80"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M30.785 9.08672C30.676 8.83147 30.567 8.57621 30.3854 8.35742C30.567 8.57621 30.676 8.83147 30.785 9.08672Z",
  fill: "#462B80"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M59.3554 28.025C57.5525 29.7992 55.1151 30.7948 52.5747 30.7948C50.0342 30.7948 47.5968 29.7992 45.7939 28.025C43.3282 25.5809 43.2871 23.1775 43.2871 17.1079C43.2871 11.0382 43.3282 8.63481 45.7939 6.19066C47.5968 4.41652 50.0342 3.4209 52.5747 3.4209C55.1151 3.4209 57.5525 4.41652 59.3554 6.19066C61.8212 8.63481 61.8623 11.0382 61.8623 17.1079C61.8623 23.1775 61.8212 25.5809 59.3554 28.025ZM57.7116 7.372C56.3392 6.04041 54.4951 5.2947 52.5747 5.2947C50.6542 5.2947 48.8102 6.04041 47.4378 7.372C45.5063 9.28658 45.3419 11.3641 45.3419 17.1486C45.3419 22.9331 45.5063 25.0106 47.4378 26.9252C48.8102 28.2568 50.6542 29.0025 52.5747 29.0025C54.4951 29.0025 56.3392 28.2568 57.7116 26.9252C59.6431 25.0106 59.8075 22.9331 59.8075 17.1486C59.8075 11.3641 59.6308 9.28658 57.7116 7.372Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M90.2688 29.7782V19.0082C90.2688 15.6608 88.4512 13.8314 85.1878 13.8314C82.007 13.8314 79.9829 15.7386 79.9829 18.6968V29.7899H78.0001V19.0082C78.0001 15.6608 76.1825 13.8314 72.9191 13.8314C69.6557 13.8314 67.7142 15.7386 67.7142 19.0082V29.7899H65.7727V12.4185H67.7142V14.4814C68.3889 13.748 69.228 13.165 70.171 12.7746C71.114 12.3842 72.1374 12.196 73.167 12.2239C75.8933 12.2239 78.0001 13.3526 79.1154 15.4156C79.7679 14.4069 80.6931 13.5798 81.7964 13.019C82.8998 12.4582 84.1415 12.1837 85.3943 12.2239C87.1884 12.1629 88.937 12.7633 90.2688 13.8976C91.508 15.0263 92.169 16.6611 92.169 18.724V29.8171L90.2688 29.7782Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M109.676 29.7782V19.0084C109.676 15.661 107.8 13.8317 104.432 13.8317C101.065 13.8317 99.061 15.7389 99.061 19.0084V29.7899H97.0574V12.4188H99.061V14.4817C99.751 13.7415 100.616 13.1539 101.591 12.7628C102.565 12.3718 103.624 12.1877 104.688 12.2242C106.82 12.2242 108.525 12.808 109.761 13.8978C110.997 14.9877 111.722 16.6613 111.722 18.7242V29.8171L109.676 29.7782Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M116.61 5.74057V3.4209H118.565V5.74057H116.61ZM116.812 29.7772V11.9397H118.397V29.8172L116.812 29.7772Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M131.275 30.7948C126.446 30.7948 123.454 27.2663 123.454 21.5072C123.454 15.7481 126.446 12.2196 131.275 12.2196C133.709 12.2196 135.225 12.8685 137.141 15.0181L135.864 16.2348C134.347 14.4908 133.15 13.923 131.275 13.923C130.349 13.8863 129.43 14.0861 128.6 14.5042C127.771 14.9222 127.058 15.5452 126.526 16.3159C125.648 17.6137 125.289 19.0738 125.289 21.5072C125.289 23.9406 125.608 25.3601 126.526 26.6985C127.058 27.4693 127.771 28.0922 128.6 28.5102C129.43 28.9283 130.349 29.1281 131.275 29.0914C133.15 29.0914 134.347 28.5236 135.864 26.7796L137.141 27.9964C135.225 30.1459 133.709 30.7948 131.275 30.7948Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M152.902 30.5841V28.4018C152.256 29.1848 151.447 29.8065 150.535 30.2201C149.622 30.6338 148.631 30.8286 147.635 30.79C145.64 30.79 144.044 30.1724 142.887 29.0194C141.729 27.8665 141.051 26.0959 141.051 23.9136V12.2196H142.926V23.6254C142.926 27.1665 144.682 29.1018 147.835 29.1018C150.987 29.1018 152.863 27.0842 152.863 23.6254V12.2196H154.738V30.6253L152.902 30.5841Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M170.819 15.2077C170.36 14.741 169.782 14.3746 169.132 14.1378C168.481 13.9011 167.776 13.8005 167.074 13.8442C163.64 13.8442 161.722 16.2986 161.722 19.1036V29.8171H159.626V12.4417H161.722V14.7519C162.882 13.1157 165.201 12.2196 167.564 12.2196C169.482 12.2196 170.953 12.6482 172.336 13.8948L170.819 15.2077Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M174.302 21.9128C174.302 26.4957 176.391 29.0508 180.241 29.0508C182.412 29.0508 183.723 28.4019 185.28 26.8608L186.713 27.9964C184.87 29.8214 183.15 30.7948 180.118 30.7948C175.08 30.7948 172.335 27.5502 172.335 21.5072C172.335 15.667 175.08 12.2196 179.668 12.2196C184.256 12.2196 187 15.5453 187 21.0611V21.9128H174.302ZM184.419 16.9648C184.008 16.0584 183.34 15.2891 182.497 14.7494C181.654 14.2098 180.672 13.9226 179.668 13.9226C178.664 13.9226 177.681 14.2098 176.838 14.7494C175.996 15.2891 175.328 16.0584 174.916 16.9648C174.466 18.1004 174.343 18.6682 174.261 20.3716H185.034C184.993 18.6682 184.882 18.1126 184.419 16.9648Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_10214_398277",
  x1: 9.13081,
  y1: 5.23075,
  x2: 17.9935,
  y2: 2.63585,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2F0B75"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#2F0B75"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#9B51E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_10214_398277",
  x1: 22.1316,
  y1: 28.8434,
  x2: 13.2707,
  y2: 31.4415,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2F0B75"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#2F0B75"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#9B51E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_10214_398277",
  x1: 6.22234,
  y1: 29.2017,
  x2: 3.08525,
  y2: 21.6942,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2F0B75"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#2F0B75"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#9B51E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_10214_398277",
  x1: 0.60954,
  y1: 14.7775,
  x2: 5.51546,
  y2: 8.49169,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2F0B75"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#2F0B75"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#9B51E0"
})));

var SvgOmnicureTextIcon = function SvgOmnicureTextIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 35,
    viewBox: "0 0 187 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOmnicureTextIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/OmnicureTextIcon.55a801db.svg";
export { ForwardRef as ReactComponent };